// extracted by mini-css-extract-plugin
export var base = "textarea-module--base--a181d";
export var error = "textarea-module--error--4ed33";